/* eslint camelcase: 0 */
import { User, UserRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IUserProps, EmptyUserPropsFactory } from '@/entities/User'
import { EmptyFilePropsFactory } from '@/entities/File'

export const toUserProps = (props: User | null | undefined): IUserProps => {
  if (!props) {
    return EmptyUserPropsFactory()
  }

  const {
    id,
    company_id,
    industry_id,
    industry,
    hospitals,
    pharmaceuticals,
    departments,
    username,
    login,
    fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    icon,
    approval,
    name,
    properties,
    flags,
    job,
    supervisor,
    payments,
    application,
    maintenance,
    certificate,
    files,
    status,
    activation,
    favorite,
    approve,
    note,
    common,
    withdrawed_at,
    locked_at,
    canceled_at,
    stopped_at,
    joined_at,
    created_at,
    updated_at
  } = props

  return EmptyUserPropsFactory({
    id,
    companyId: company_id,
    industryId: industry_id,
    industry,
    hospitals,
    pharmaceuticals,
    departments,
    username,
    login,
    fcmToken: fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    icon,
    approval,
    name,
    properties,
    flags,
    job,
    supervisor,
    payments,
    application,
    maintenance,
    certificate,
    favorite,
    files: {
      image: EmptyFilePropsFactory(files?.image),
      card: EmptyFilePropsFactory(files?.card)
    },
    status,
    activation,
    approve,
    note: note === '' ? null : note,
    common: common === '' ? null : common,
    withdrawedAt: withdrawed_at,
    lockedAt: locked_at,
    canceledAt: canceled_at,
    stoppedAt: stopped_at,
    joinedAt: joined_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toUserRequest = (props: IUserProps): UserRequest => {
  const { favorite, note, common, approval } = props

  return {
    favorite,
    note,
    common,
    approval
  }
}
